import * as types from '../actions';

export default function(state:any = [], action:any = '') {
  const response = action.response;
  if (action.type === types.REGISTER_USER_SUCCESS) {
    return { ...state, response };
  } else {
    return state;
  }
}